import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import * as contactActions from 'actions/contactActions';
import * as formActions from 'actions/formActions';
import ContactForm from 'components/contacts/ContactForm';
import Logger from 'util/Logger';
import { useParams, useNavigate } from 'react-router-dom';  // Import hooks
import {
  Header,
  HeaderButtonNav,
  HeaderButton,
  HeaderTitle
} from 'components/layout';
import * as operationsApi from 'api/operationsApi';

const ContactFormPage = () => {
  const [loaded, setLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [contact, setContact] = useState(null);

  const { action: mode, id: contactId } = useParams();  // Use useParams to get params
  const navigate = useNavigate();  // Use useNavigate to navigate programmatically
  const dispatch = useDispatch();

  useEffect(() => {
    if (mode === 'edit') {
      getContact(contactId);
    }
  }, [mode, contactId]);

  const getContact = async (contactId) => {
    try {
      const result = await operationsApi.getContact(contactId);
      setContact(result.data);
      setLoaded(true);
    } catch (error) {
      Logger.error('Failed to load contact', error);
    }
  };

  const createOrUpdateSuccess = (message) => {
    setIsSubmitting(false);
    dispatch(contactActions.getContacts()); // Assuming you need to refetch contacts
    Logger.success(message);
    navigate('/contacts');
  };

  const createContact = (formValues) => {
    setIsSubmitting(true);
    operationsApi.createNewContact(formValues).then(() => {
      createOrUpdateSuccess('New Contact Created');
    });
  };

  const updateContact = (formValues) => {
    setIsSubmitting(true);
    operationsApi.updateContact(formValues).then(() => {
      createOrUpdateSuccess('Contact Updated');
    });
  };

  const cancel = () => {
    navigate('/contacts');
  };

  if (mode === 'edit' && !loaded) {
    return null; // Optionally show a loading spinner
  }

  return (
    <div>
      <Header>
        <HeaderButtonNav>
          <HeaderButton
            color="primary"
            onClick={cancel}
            ligature="clear"
          />
        </HeaderButtonNav>
        <HeaderTitle
          label={mode === 'edit' ? 'Modify existing contact' : 'Create a New Contact'}
        />
      </Header>
      <ContactForm
        onSubmit={mode === 'edit' ? updateContact : createContact}
        isSubmitting={isSubmitting}
        initialValues={mode === 'edit' ? contact : {}}
      />
    </div>
  );
};

ContactFormPage.propTypes = {
  // No need to define prop types for history, match, etc. since we're using hooks
};

export default ContactFormPage;

